var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2858 1.99988H1.71439C1.08321 1.99988 0.571533 2.51155 0.571533 3.14274V12.857C0.571533 13.4882 1.08321 13.9999 1.71439 13.9999H14.2858C14.917 13.9999 15.4287 13.4882 15.4287 12.857V3.14274C15.4287 2.51155 14.917 1.99988 14.2858 1.99988Z",
    stroke: "#888888",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.571533 3.42847L7.26868 9.14275C7.47403 9.3138 7.73284 9.40747 8.0001 9.40747C8.26737 9.40747 8.52618 9.3138 8.73153 9.14275L15.4287 3.42847",
    stroke: "#888888",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailicon);
export default __webpack_public_path__ + "static/media/emailicon.e74f6f4309be78b8ab135d59448b6181.svg";
export { ForwardRef as ReactComponent };